import { Injectable } from '@angular/core';
@Injectable()
export class AdminEffects {

  // @Effect()
  // loadAdminState$: Observable<Action> = this.actions$
  //   .ofType(AdminActionTypes.LoadAdminState)
  //   .startWith(new LoadAdminState())
  //   .switchMap(() =>
  //   // You can pull from offline state here or get data from a server via an api
  //   // An example of inserting data into offline state can be found in login.effects.ts
  //     this.db.query('admin')
  //       .map((state: IAdmin) => new LoadAdminStateSuccess(state))
  //       .catch(error => Observable.of(new LoadAdminStateFail(error)))
  //   );

}